import { render, staticRenderFns } from "./newbaseplan.vue?vue&type=template&id=54deac38&scoped=true&"
import script from "./newbaseplan.vue?vue&type=script&lang=js&"
export * from "./newbaseplan.vue?vue&type=script&lang=js&"
import style0 from "./newbaseplan.vue?vue&type=style&index=0&id=54deac38&prod&lang=scss&scoped=true&"
import style1 from "./newbaseplan.vue?vue&type=style&index=1&id=54deac38&prod&lang=css&"
import style2 from "./newbaseplan.vue?vue&type=style&index=2&id=54deac38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54deac38",
  null
  
)

export default component.exports